export const roundToDecimal = (value: number) => {
  const roundedValue = Number(value).toFixed(2);
  return roundedValue === '0.00' ? '<0.00' : roundedValue;
};

export const roundToDecimalFull = (value: number) => {
  return Number(value).toFixed(2);
};
